export default function () {
    return {
        activeFilters: {},
    }
}
